import api from '../utils/api';

class AddonsApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/addons', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getOne = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/addons/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/addons', data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/addons/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/addons/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}

const addonsApi = new AddonsApi();
export default addonsApi;
